import { render } from "./ChangeSharedFSServiceOffering.vue?vue&type=template&id=a5530dec&scoped=true"
import script from "./ChangeSharedFSServiceOffering.vue?vue&type=script&lang=js"
export * from "./ChangeSharedFSServiceOffering.vue?vue&type=script&lang=js"

import "./ChangeSharedFSServiceOffering.vue?vue&type=style&index=0&id=a5530dec&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.23.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5530dec"]])

export default __exports__